import { Component, Currency } from "macguffin"

import { Tween } from "@tweenjs/tween.js"

const STEP_SOUND_INTERVAL = 5

export default class SummaryLine extends Component {

    constructor() {
        super()

        const summaryFormat = {
            showCurrency: true,
            useSeparators: true,
            showSubUnits: true
        }

        this.state = {
            summaryFormat,
            value: 0
        }
    }

    componentDidMount() {
        const { props } = this
        const { value, onCountUpComplete, duration } = props

        const counter = { value: 0}

        const countUp = new Tween(counter)
            .to({ value }, duration)
            .onUpdate(() => {
                const { value } = counter

                if (!(Math.floor(value) % STEP_SOUND_INTERVAL)) {
                    props.winCountUpStep(value)
                }

                this.setState({ value })
            })
            .onComplete(onCountUpComplete)
            .start()
    }


    render() {
        const { props, state } = this
        const { label, labelStyle, valueStyle } = props
        const { value, summaryFormat } = state

        return <div className="summaryLine">
            <h1 style={labelStyle}>
                {this.t(label)}
            </h1>
            <h1 style={valueStyle}>
                {Currency.format(value, summaryFormat)}
            </h1>
        </div>
    }
}
